import { Component, OnInit } from '@angular/core';
import { TravelService } from 'src/app/service/travel.service';
import { ConfigProvider } from 'src/app/service/config.service';
import { Calculate, Franchise, Insurance, PolicyObject, PolicyOptions } from 'src/app/shared/insurance.model';
import * as _moment from 'moment';
import { getFromLocalStorage, setToLocalStorage } from 'src/app/shared/helpers';

@Component({
  selector: 'app-filled-info',
  templateUrl: './filled-info.component.html',
  styleUrls: ['./filled-info.component.scss']
})
export class FilledInfoComponent implements OnInit {

  calculate: Calculate;
  options: PolicyOptions[];
  travel: any;
  type: number;
  franchise: number;
  age: number;
  insurance: Insurance;
  id: number;
  duration: number;
  config: object;
  selectedPolicy: PolicyOptions[];
  selectedFranchise: Franchise[];
  franchiseOptions: Franchise[];
  price: number;
  dd: any[];
  policy : any;

  constructor(public aldagi: TravelService, configProvider: ConfigProvider) {
    this.config = configProvider.getConfig();
  }

  get result(): any {
    return JSON.parse(localStorage.getItem('policy'));
  }

  get data(): any {
    return JSON.parse(localStorage.getItem('calculate'));
  }

  ngOnInit(): void {
    this.options = this.config['POLICY_TYPES'];
    this.franchiseOptions = this.config['FRANCHISE_TYPES'];

    if (localStorage.getItem('type') === 'once') {
      // calculate days
      const duration = _moment
        .duration(
          _moment(this.result.InsurancePeriod.endDate).diff(
            _moment(this.result.InsurancePeriod.startDate)
          )
        )
        .asDays()  + 1;

      this.duration =  Math.ceil(duration);
    }

    if (localStorage.getItem('type') === 'multiple') {
      this.duration = parseInt(this.result.InsuranceDays.days);
    }

    //travel type
    switch (this.result.InsuranceType.type) {
      case 'once':
        this.type = 1;
        break;
      case 'multiple':
        this.type = 2;
        break;
    }

    // franchise
    switch (this.result.PolicyType.franchise) {
      case true:
        this.franchise = 1;
        break;
      case false:
        this.franchise = 2;
        break;
    }
    //get age of travellers

     let policy = getFromLocalStorage('policy') as PolicyObject;
    
     console.log(policy);
     if(policy.InsuranceType.type=="multiple")
     {
        this.age = this.getAgeAfterTravel(_moment(this.result.PersonalInfo.birthDate), this.addDays(new Date(), 365));
     }
     else
     {
     this.age=  this.getAgeAfterTravel(_moment(this.result.PersonalInfo.birthDate), policy.InsurancePeriod.endDate);
     }
    const travellers = [
      {
        dateOfBirth: this.age
      }
    ];
    this.result.PassengerInfo
    if ((JSON.parse(JSON.stringify(getFromLocalStorage('policy')))).PassengerInfo) {
      travellers.push({
        dateOfBirth: this.result.PassengerInfo?.map(i => ({
          dateOfBirth: this.getAgeAfterTravel(_moment(i.birthDate), policy.InsurancePeriod.endDate)
        }))
      });
    }

    console.log(this.age);
    // get array of age
    const out = travellers.flatMap(function r(el) {
      return Array.isArray(el.dateOfBirth)
        ? el.dateOfBirth.flatMap(r)
        : el.dateOfBirth;
    });

    // final data
    this.travel = {
      travelTypeId: this.type,
      withCovid: this.result.PolicyType.covid,
      travelPeriodInDays: this.duration,
      travelFranchiseTypeId: this.franchise,
      listOfTravellerCountPerAgeRange: [
      ],
    };

    console.log('Age types')
    console.log(out);
    //age types
    this.travel.listOfTravellerCountPerAgeRange = out.reduce((acc, a) => {
      console.log(a)
      let id
      //infant
      if (a >= 0 && a <= 1) {
        id = 1;
        //child
      } else if (a >= 2 && a <= 11) {
        id = 2;
      } //adult
      else if (a >= 12 && a <= 59) {
        id = 3;
      } //pensioner
      else if (a >= 60 && a <= 64) {
        id = 4;
      }
      else if (a >= 65 && a <= 69) {
        id = 5;
      }
      const record = acc.find((entry) => entry.travellerAgeRangeId === id);
      if (record) {
        record.travellerCount += 1;
      } else {
        acc.push({ travellerAgeRangeId: id, travellerCount: 1 });
      }
      return acc;
    }, []);

    this.selectedPolicy = this.options.filter(
      p => p.id === this.travel.policyType
    );

    this.selectedFranchise = this.franchiseOptions.filter(
      p => p.id === this.travel.travelFranchiseTypeId
    );

    localStorage.setItem('calculate', JSON.stringify(this.travel));

    // calculate premium

    this.aldagi.calculatePremiums(this.travel).subscribe(data => {
      this.options.map((p: PolicyOptions) => {
        const c = data.find(d => d.travelProductId === p.id);
        this.price = c.premium;
      });
    });

    this.aldagi.calculateAgain();
  }
    // get age after travel
    getAgeAfterTravel(dateString, travelPeriod) {
      var today = new Date(travelPeriod);
      var birthDate = new Date(dateString);
      var age = today.getFullYear() - birthDate.getFullYear();
      var m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      return age;
    }
    

    addDays(date, days) {
      console.log('original date was' + date)
      const newDate = new Date(date.getTime() 
          + days * 24 * 60 * 60 * 1000);
          console.log('new date is' + newDate)
      return newDate;
  }
}
